@if(passportEnabled()){
    <div class="passport-fab-container">
        <button type="button" (click)="handleClick()" [attr.aria-label]="'Pasaporte digital' | translate">
            <div class="icon">
                <passport-icon />
            </div>
            <span class="ci-paragraph-p1-semibold">{{ 'Pasaporte digital' | translate }}</span>
        </button>
    </div> 
}